var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { TooManyRequestsError } from '@lucidlink/sdk/fetcher';
import { MessageBox, Trans } from '@lucidlink/uicore';
import { TOO_MANY_REQUESTS_ERROR_CODE } from '#constants';
import { TickingMessageBox } from './TickingMessageBox';
export const SendCodeErrorBox = ({ 'data-testid': testId, error, onCountDown, }) => {
    if (!error) {
        return null;
    }
    if (error instanceof TooManyRequestsError) {
        return (_jsx(TickingMessageBox, { code: TOO_MANY_REQUESTS_ERROR_CODE, countDownTo: error.retryAfter, "data-testid": testId, onCountDown: onCountDown, type: "negative" }));
    }
    return (_jsx(MessageBox, { "data-testid": testId, type: "negative", children: _jsx(Trans, { children: "Sending verification code failed. Please try again." }) }));
};
_react_refresh_temp_1 = SendCodeErrorBox;
$RefreshReg$(_react_refresh_temp_1, "SendCodeErrorBox");
